module.exports = __webpack_public_path__ + "static/media/home_japan_main.e61fd07b.svg";